//============================================================================
// Name        : Reception.tsx
// Purpose     : Implement Warehouse search receptionUI
// Created     : 2019-06-21
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

// tslint:disable-next-line: no-unused-expression
/** @jsx jsx */ jsx;
import { jsx } from "@emotion/core";
import axios from "axios";
import React from "react";
import Moment from "moment";
import PreventAutofill from "../../PreventAutofill";
import { ChangeInputEvent, IItem, IReceptionProps, IReceptionState, ReceiveStatuses } from "./types";

export default class Reception extends React.Component<IReceptionProps, IReceptionState> {
    constructor(props: any) {
        super(props);
        this.state = {
            query: "",
            receptionItems: new Array<IItem>(),
            apiLogs: null
        };
    }

    onChange = (event: ChangeInputEvent) => {
        const newState = { [event.target.name]: event.target.value };
        this.setState(newState as unknown as IReceptionState);
    }
    shouldSearch = (e) => {
        if (e.key == "Enter") {
            this.onSearch();
        }
    }
    onSearch = async () => {
        // Don't search with an empty field
        if (this.state.query.trim().length == 0) {
            return;
        }

        const resp = await axios.get(this.props.searchUrl + `.json?search=${this.state.query}`);
        const apiLogs = resp.data.api_logs;
        const receptionItems = (resp.data.records as IItem[]).sort((a, b) => {
            if (a === b) { return 0; }
            if (a.status == ReceiveStatuses.Pending || a.status == ReceiveStatuses.InProgress) { return -1; }
            if (a.status == ReceiveStatuses.Complete) { return 1; }
        });
        this.setState({ receptionItems, apiLogs });
    }
    getReceiveUrl = (itemId: number) => {
        return `${this.props.receiveUrl}?id=${itemId}`;
    }

    onGoToReceivePage = (url: string) => {
        // $("#pin-auth-dialog #redirect_url").val(url);
        // window.PinAuthentication.showPinLogin();
        location.href = url;
    }

    render() {
        if (this.state.apiLogs == null) {
            return(
                <React.Fragment>
                    {/* Search */}
                    <div className="center-row mgnbottom20px">
                        <div className="search-container">
                            <div css={{ display: "flex" }}>
                                <div css={{ textAlign: "center" }}>
                                    <PreventAutofill/>
                                    <input type="text" id="searchField" name="query" value={this.state.query} onChange={this.onChange} onKeyPress={this.shouldSearch} autoComplete={this.state.query} placeholder={"Search by PO#, Vendor\'s Name"}  style={{width: "400px"}} />
                                </div>
                                <button css={{ height: 39 }} className="man-btn" id="searchBtn" onClick={this.onSearch}>
                                    <i className="fa fa-search"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* /Search */}

                    {/* Search Results */}
                    <div className="row">
                        <div className="table-responsive col-md-12">
                            <h1 className=" jumbotron alert-info bold text-center">Search for the PO number</h1>
                        </div>
                    </div>
                    {/* /Search Results */}
                </React.Fragment>
            );
        }
        if (this.state.receptionItems.length > 0) {
            return (
                <React.Fragment>
                    {/* Search */}
                    <div className="center-row mgnbottom20px">
                        <div className="search-container">
                            <div css={{ display: "flex" }}>
                                <div css={{ textAlign: "center" }}>
                                    <PreventAutofill/>
                                    <input type="text" id="searchField" name="query" value={this.state.query} onChange={this.onChange} onKeyPress={this.shouldSearch} autoComplete={this.state.query} placeholder={"Search by PO#, Vendor\'s Name"}  style={{width: "400px"}} />
                                </div>
                                <button css={{ height: 39 }} className="man-btn" id="searchBtn" onClick={this.onSearch}>
                                    <i className="fa fa-search"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* /Search */}

                    {/* Search Results */}
                    <div className="row">
                        <div className="table-responsive col-md-12">
                            <table className="table table-bordered table-striped searchTable">
                                <thead className="thead-inverse">
                                <tr>
                                    <th className={"text-center"}>Action</th>
                                    <th className={"text-center"}>PO</th>
                                    <th className={"text-center"}>Due Date</th>
                                    <th>Vendor</th>
                                    <th className={"text-center"}>Status</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.receptionItems.map((reception: IItem, key) =>
                                    <tr key={key}>
                                        <td className={"text-center"}>
                                            {(reception.status == ReceiveStatuses.Pending) &&
                                            <button onClick={() => { this.onGoToReceivePage(this.getReceiveUrl(reception.id)); }} className="man-btn man-green-btn">Receive</button>}
                                            {(reception.status == ReceiveStatuses.InProgress) &&
                                            <button onClick={() => { this.onGoToReceivePage(this.getReceiveUrl(reception.id)); }} className="man-btn man-green-btn">Receive</button>}
                                            {(reception.status == ReceiveStatuses.Complete) &&
                                            <button onClick={() => { this.onGoToReceivePage(this.getReceiveUrl(reception.id)); }} className="man-btn">Undo</button>}
                                        </td>
                                        <td className={"text-center"}>{reception.receiving_id}</td>
                                        <td className={"text-center"}>
                                            {/* tslint:disable-next-line:no-bitwise */}
                                            {Moment(reception.expected_receipt_date, "YYYY-MM-DDThh:mm:ss").format('YYYY-MM-DD, h:mm:ss a')}
                                        </td>
                                        <td>{reception.vendor_name}</td>
                                        <td className={"text-center"}>
                                            {(reception.status == ReceiveStatuses.Pending) &&
                                            <span className="label label-danger">PENDING</span>}
                                            {(reception.status == ReceiveStatuses.InProgress) &&
                                            <span className="label label-warning">IN-PROGRESS</span>}
                                            {(reception.status == ReceiveStatuses.Complete) &&
                                            <span className="label label-success">COMPLETED</span>}
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {/* /Search Results */}
                </React.Fragment>
            );
        }
        if (this.state.receptionItems.length == 0 && this.state.apiLogs) {
            return(
                <React.Fragment>
                    {/* Search */}
                    <div className="center-row mgnbottom20px">
                        <div className="search-container">
                            <div css={{ display: "flex" }}>
                                <div css={{ textAlign: "center" }}>
                                    <PreventAutofill/>
                                    <input type="text" id="searchField" name="query" value={this.state.query} onChange={this.onChange} onKeyPress={this.shouldSearch} autoComplete={this.state.query} placeholder={"Search by PO#, Vendor\'s Name"}  style={{width: "400px"}} />
                                </div>
                                <button css={{ height: 39 }} className="man-btn" id="searchBtn" onClick={this.onSearch}>
                                    <i className="fa fa-search"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* /Search */}

                    {/* Search Results */}
                    <div className="row">
                        <div className="table-responsive col-md-12">
                            <table className="table table-bordered table-striped searchTable">
                                <thead className="thead-inverse">
                                <tr>
                                    <th className={"text-center"}>Action</th>
                                    <th className={"text-center"}>PO</th>
                                    <th className={"text-center"}>Due Date</th>
                                    <th>Vendor</th>
                                    <th className={"text-center"}>Status</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className={"text-center"} colSpan={5}>
                                        <h1 className=" jumbotron alert-info bold">No PO's found with the search details, kindly contact office</h1>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {/* /Search Results */}
                </React.Fragment>
            );
        }
        if (this.state.receptionItems.length == 0 && !this.state.apiLogs) {
            return(
                <React.Fragment>
                    {/* Search */}
                    <div className="center-row mgnbottom20px">
                        <div className="search-container">
                            <div css={{ display: "flex" }}>
                                <div css={{ textAlign: "center" }}>
                                    <PreventAutofill/>
                                    <input type="text" id="searchField" name="query" value={this.state.query} onChange={this.onChange} onKeyPress={this.shouldSearch} autoComplete={this.state.query} placeholder={"Search by PO#, Vendor\'s Name"}  style={{width: "400px"}} />
                                </div>
                                <button css={{ height: 39 }} className="man-btn" id="searchBtn" onClick={this.onSearch}>
                                    <i className="fa fa-search"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* /Search */}

                    {/* Search Results */}
                    <div className="row">
                        <div className="table-responsive col-md-12">
                            <table className="table table-bordered table-striped searchTable">
                                <thead className="thead-inverse">
                                <tr>
                                    <th className={"text-center"}>Action</th>
                                    <th className={"text-center"}>PO</th>
                                    <th className={"text-center"}>Due Date</th>
                                    <th>Vendor</th>
                                    <th className={"text-center"}>Status</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className={"text-center"} colSpan={5}>
                                        <h1 className=" jumbotron alert-info bold">No PO's found with the search details, kindly contact Senitron customer support or office</h1>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {/* /Search Results */}
                </React.Fragment>
            );
        }
    }
}
